import { UserGroupRulesSection } from "./UserGroupRulesSection";
import { ClickHousePoliciesSection } from "./ClickHousePoliciesSection";
import type { UserGroupRulesStats, Policy } from "../../services/rbac";

interface DatabaseTabProps {
  database: string;
  rulesData: UserGroupRulesStats | null;
  policiesByDatabase: Record<string, Record<string, Policy[]>>;
  expandedRows: Set<string>;
  toggleRow: (rowKey: string) => void;
}

export const DatabaseTab = ({
  database,
  rulesData,
  policiesByDatabase,
  expandedRows,
  toggleRow,
}: DatabaseTabProps) => {
  return (
    <div className="al-space-y-6 al-mt-6">
      {rulesData && <UserGroupRulesSection database={database} rulesData={rulesData} />}
      <ClickHousePoliciesSection
        database={database}
        policiesByDatabase={policiesByDatabase}
        expandedRows={expandedRows}
        toggleRow={toggleRow}
      />
    </div>
  );
};
